module.exports = __webpack_public_path__ + "static/img/205.7140e96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/205.png
// module id = GGJP
// module chunks = 0